import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-32 text-center" data-testid="not-found-page">
      <SEO title="Page Not Found — S H & SONS ®" description="This page does not exist." noindex />
      <p className="h-display text-8xl sm:text-[140px] text-ink/10">404</p>
      <img src="/assets/monogram-black.svg" alt="S H & SONS ® monogram" className="h-12 mx-auto -mt-6 opacity-70" />
      <h1 className="mt-4 text-2xl sm:text-3xl font-light">This page has moved, or never was</h1>
      <Link to="/" data-testid="not-found-home-link" className="pill-dark mt-10 px-8">Back to Home</Link>
    </div>
  );
}
